import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import UnsavedHeader from '../../../common/UnsavedHeader';
import { parseError } from '../../../../helpers';

import {
  fetchSupplyById,
  updateSupply,
  editCurrentSupply,
  updateSupplyFact,
  setCurrentSupplyConfirmStatus,
  fetchGetSupplyHistory,
} from '../../../../actions/supplies';

import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import Adaptive from '../../../common/Adaptive';

const SingleSuppliePage = (props) => {
  const supplyId = props.match.params.id === 'new' ? null : props.match.params.id;
  const isNew = supplyId === null;
  const { setCustomHeader, history } = props;

  const dispatch = useDispatch();
  const currentSupply = useSelector((state) => state.supplies.currentSupply);
  const getCurrentSupply = useSelector((state) => state.supplies.getCurrentSupply);
  const currentSupplyUnsaved = useSelector((state) => state.supplies.currentSupplyUnsaved);
  const warehouses = useSelector((state) => state.orders.warehouses);
  const [saveLoading, setSaveLoading] = useState(false);
  const [quantityFactChange, setQuantityFactChange] = useState(false);
  const [supplyHistory, setSupplyHistory] = useState(null);
  const [supplyCustomId, setSupplyCustomId] = useState(null);

  const currentWarehouse = currentSupply
    ? warehouses.find((w) => w.code === currentSupply.warehouseCode)
    : null;
  const isManualSupply = currentWarehouse && currentWarehouse.operatorType === 'MANUAL';

  const otherBlockRef = useRef();

  useEffect(() => {
    if (supplyId) {
      (async function () {
        const historyEvents = await dispatch(fetchGetSupplyHistory(supplyId));
        setSupplyHistory(historyEvents);
      })();
    }
  }, []);

  useEffect(() => {
    dispatch(fetchSupplyById(supplyId)); //TODO переделать, убрать состояние поставки из redux. Все храним в локальном сторе.
    setQuantityFactChange(false);
  }, [supplyId]);

  useEffect(() => {
    setCustomHeader(
      currentSupplyUnsaved ? (
        <UnsavedHeader handleSubmit={handleSaveSupply} loading={saveLoading} />
      ) : null,
    );
  }, [currentSupplyUnsaved, saveLoading, currentSupply, quantityFactChange]);

  const handleWarehouseChange = (childrenWarehouseCode, warehouseCode) => {
    const newWarehouse = warehouses.find((w) => w.code === warehouseCode);
    const isNewManualSupply = newWarehouse && newWarehouse.operatorType === 'MANUAL';

    dispatch(
      editCurrentSupply({
        ...currentSupply,
        warehouseCode: childrenWarehouseCode.code ? childrenWarehouseCode.code : warehouseCode,
        warehouseName: newWarehouse ? newWarehouse.title : currentSupply.warehouseName,
        confirmStatus:
          isManualSupply && !isNewManualSupply
            ? 'NEED_CONFIRM'
            : currentSupply.confirmStatus || null,
      }),
    );
  };

  const saveSupply = async (saveFactQuantity) => {
    try {
      await otherBlockRef.current.submitOtherBlock();

      if (isManualSupply) {
        await dispatch(setCurrentSupplyConfirmStatus('APPROVED'));
      }

      const id = await dispatch(updateSupply(supplyCustomId));
      if (isManualSupply && (quantityFactChange || saveFactQuantity)) {
        try {
          await dispatch(updateSupplyFact());
        } catch (error) {
          console.error(error);
          toast.error(`Ошибка обновления фактического количества товара`);
        }
      }
      const savedSupply = await dispatch(fetchSupplyById(id));
      setQuantityFactChange(false);
      setSaveLoading(false);
      //Здесь supplyId пока из рутера. Поскольку мы рока не меняли роут он еще пустой если запись добавлена
      if (!supplyId) {
        history.replace(`/supplies/${savedSupply.id}`);
      }
    } catch (err) {
      //toast.error(parseError(err));
      throw err;
    }
  };

  const handleSaveSupply = () => {
    saveSupply(true)
      .then(() => toast.info('Поставка успешно обновлена'))
      .catch((err) => toast.error(parseError(err)));
  };

  const isSupplyClosed =
    currentSupply &&
    (currentSupply.status === 'COMPLETED' ||
      currentSupply.status === 'COMPLETED_WITH_DIFFERENCE' ||
      currentSupply.status === 'CANCELED');

  const adaptiveProps = {
    isNew,
    getCurrentSupply,
    currentSupply,
    currentWarehouse,
    saveSupply,
    setQuantityFactChange,
    supplyHistory,
    handleWarehouseChange,
    isSupplyClosed,
    otherBlockRef,
    supplyCustomId,
    setSupplyCustomId,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopLayout}
      MobileComponent={MobileLayout}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default SingleSuppliePage;
